<template>
    <div
        id="app-component"
        class="content"
    >
        <TheHeader />

        <transition
            name="fade"
            mode="out-in"
        >
            <div
                v-if="$store.state.auth.user || $route.name === 'login'"
                key="content"
            >
                <TheSidebar />

                <div
                    class="page"
                    :class="{'sidebar-minified': $store.state.minified && $store.state.auth.checked}"
                >
                    <div class="col-12 pb-5">
                        <transition name="fade">
                            <keep-alive :include="keepAlive">
                                <router-view />
                            </keep-alive>
                        </transition>
                    </div>
                </div>

                <ConfirmModal />

                <AlertList />

                <ClientCalls />
            </div>

            <div
                v-else
                key="loader"
                class="mt-5 pt-5"
            >
                <BaseLoader />
            </div>
        </transition>
    </div>
</template>

<script>
    import TheSidebar from "./templates/TheSidebar"
    import TheHeader from "./templates/TheHeader"
    import AlertList from "./templates/AlertList"
    import ConfirmModal from "./modals/ConfirmModal"
    import BaseLoader from "./templates/BaseLoader"
    import ClientCalls from "./templates/ClientCalls"

    export default {
        name: "App",

        components: {
            ClientCalls,
            BaseLoader,
            ConfirmModal,
            AlertList,
            TheHeader,
            TheSidebar
        },

        data: function () {
            return {
                keepAlive: [
                    'DossiersList',
                    'StatistiquesTab',
                    'EchangesClientsList',
                    'FichesResultatsList',
                    'FichesCreationsList',
                    'ProgrammesList',
                    'ProspectsList',
                    'AlertsList',
                    'PartenairesTab',
                    'AdminTab',
                ]
            }
        },

        created: function () {
            if (this.$store.state.auth.checked) {
                this.$store.dispatch('init')
            }
        }
    }
</script>

<style lang="scss">
    @import "~sass/app";

    @import "~sass/template";

    @import "~sass/form-element";

    @import "~sass/transitions";
</style>
